// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__QkM-r","col":"CardReaderDesc_col__1SErT","label":"CardReaderDesc_label__1ipYl"};